import { render } from "./SpamEmail.vue?vue&type=template&id=1fd05f73&scoped=true"
import script from "./SpamEmail.vue?vue&type=script&lang=js"
export * from "./SpamEmail.vue?vue&type=script&lang=js"

import "./SpamEmail.vue?vue&type=style&index=0&id=1fd05f73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd05f73"]])

export default __exports__